<template>
  <b-modal id="activ" centered v-model="showActivDialog" title="النشاط" ok-only ok-title="موافق" size="md">
    <div>
      <h2 class="text-center mb-2">{{ dataDialog.ngo === null ? "الوزارة" : dataDialog.ngo.name_ar }}</h2>
    </div>
    <div>
      <h3>{{ dataDialog.title_ar }}</h3>
    </div>
    <div class="mt-2">
      <app-timeline>
        <app-timeline-item title="تاريخ بداية النشاط" :subtitle="dataDialog.from_event_duration" variant="success" />
        <app-timeline-item title="تاريخ نهاية النشاط" :subtitle="dataDialog.to_event_duration" variant="info" />
      </app-timeline>
    </div>
    <div>
      <h3 class="mt-2">التفاصيل</h3>
    </div>
    <b-card-text>{{ dataDialog.description_ar }}</b-card-text>
    <div v-if="dataDialog.ngo != null && dataDialog.ngo != undefined">
      <div>
        <h3 class="mt-2">
          <feather-icon icon="PhoneIcon" size="17" class="mx-25" /> معلومات
          التواصل
        </h3>
        <ul>
          <li v-for="(contact, i) in dataDialog.ngo.contacts" :key="i" class="mt-1">
            <img v-if="contact.type" :src="
              require(`@/assets/contacts/ngo_${contact.type.icon}.png`)
            " width="18" height="18" class="mr-1" />
            <strong v-if="contact.type">{{ contact.type.name_ar }}:</strong>
            {{ contact.value }}
          </li>
        </ul>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BButton,
  BRow,
  BCol,
  BContainer,
  BFormInput,
  BFormGroup,
  BFormSelect,
  VBModal,
  BMedia,
  BMediaBody,
  BMediaAside,
  BAvatar,
  BCardText,
  VBPopover,
} from "bootstrap-vue";

import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

import VSelect from "vue-select";
import Ripple from "vue-ripple-directive";

export default {
  props: ["dataDialog"],
  components: {
    BButton,
    BRow,
    BCol,
    BContainer,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BModal,
    VSelect,
    AppTimeline,
    AppTimelineItem,
    BMedia,
    BMediaBody,
    BMediaAside,
    BAvatar,
    BCardText,
    VBPopover,
  },

  directives: {
    "b-modal": VBModal,
    "b-popover": VBPopover,
    Ripple,
  },
  computed: {
    showActivDialog: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.$attrs.value;
      },
    },
  },
};
</script>

<style scoped>
.media {
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.modal-lg.model_activ {
  max-width: 400px;
}
</style>